<template>
    <v-row>
        <v-col cols="6" sm="8" md="6" class="shrink">
            <v-text-field v-model="appFilterStoreText" append-icon="mdi-magnify" :label="$gettext('Search')" single-line hide-details
                          rounded class="mb-2"></v-text-field>
        </v-col>
        <!-- System/Custom switch removed - apps will only show installed applications from Google Play -->
        <!-- <v-col cols="6" sm="4" md="6" class="mb-3 mt-auto text-right grow">
            <v-btn-toggle class="text-left" rounded dense v-model="chosenAppSource" :color="!isDark ? 'primary': ''">
                <v-btn small v-for="as in appsSource" :value="as.value" v-text="as.text"></v-btn>
            </v-btn-toggle>
        </v-col> -->
    </v-row>
</template>

<script>
import {computed, onMounted, ref, watch} from "vue";
import {useVuetify} from "@/composables/vuetify";
import MixinIcon from "@/mixins/MixinIcon";

export default {
    name: 'AppStoreHeader',
    mixins: [MixinIcon],
    setup(props, context) {

        let appFilterStoreText = ref('')
        // Fixed to 'system' - no more custom apps from server
        let chosenAppSource = ref('system')

        watch(appFilterStoreText, newValue => context.emit('update:appFilterStoreText', newValue))
        // Still emit the chosenAppSource but it's always 'system' now
        watch(chosenAppSource, newValue => context.emit('update:chosenAppSource', newValue))

        const vuetify = useVuetify();
        let isDark = computed(() => {
            return vuetify.theme.dark
        })

        return {
            appFilterStoreText,
            chosenAppSource,
            // appsSource commented out as System/Custom switch is removed
            // appsSource: [
            //     {
            //         value: 'system',
            //         text: 'System'
            //     },
            //     {
            //         value: 'common',
            //         text: 'Common'
            //     }
            // ],
            isDark
        }

    },
}
</script>
